<template>
    <div class="md-layout md-alignment-center-center md-size-90">
        <md-toolbar class="md-layout-item md-size-90" md-elevation="1">
            <div class="md-layout md-large-size-45 md-medium-size-90 md-small-size-90">
                <md-button v-on:click="back" class="md-icon-button">
                    <md-icon>keyboard_arrow_left</md-icon>
                </md-button>
                <h3 class="md-title">{{title}}</h3>
            </div>
            <div class="md-layout md-alignment-center-right md-large-size-45 md-medium-size-90 md-small-size-90">
                <slot></slot>
                <md-button v-if="isLayoutCard" @click="emitSwitchLayout('list')"  class="md-raised md-primary">
                    <md-icon>view_list</md-icon><label class="md-px-1">liste</label>
                </md-button>
                <md-button v-if="isLayoutList" @click="emitSwitchLayout('card')" class="md-raised md-primary">
                    <md-icon>view_module</md-icon><label class="md-px-1">carte</label>
                </md-button>
                <!--
                <md-button :disabled="isDelete == 'disabled'" v-if="isDelete || isDelete == 'disabled'" v-on:click="$emit('delete')" class="md-raised md-primary ">
                    <md-icon>delete</md-icon><label class="md-px-1 md-small-hide">Supprimer</label>
                </md-button>
                -->
                <md-button :disabled="isAdd == 'disabled'" v-if="isAdd || isAdd == 'disabled'" v-on:click="$emit('add')" class="md-raised md-primary">
                    <md-icon>add</md-icon><label class="md-px-1 md-small-hide">Nouveau</label>
                </md-button>
                <md-button :disabled="isEdit == 'disabled'" v-if="isEdit || isEdit == 'disabled'" v-on:click="$emit('edit')" class="md-raised md-primary ">
                    <md-icon>edit</md-icon><label class="md-px-1 md-small-hide">Modifier</label>
                </md-button>
                <md-button :disabled="isSave == 'disabled'" v-if="isSave || isSave == 'disabled'" v-on:click="$emit('save')" class="md-raised md-primary">
                    <md-icon>save</md-icon><label class="md-px-1 md-small-hide">Enregistrer</label>
                </md-button>

                <md-menu md-size="auto" md-align-trigger v-if="isDelete || isDelete == 'disabled'">
                    <md-button class="md-primary md-icon-button" md-menu-trigger><md-icon>arrow_drop_down</md-icon></md-button>
                    <md-menu-content>
                        <md-button :disabled="isDelete == 'disabled'" v-on:click="$emit('delete')" class="md-primary">
                            <md-icon>delete</md-icon><label class="md-px-1 md-small-hide">Supprimer</label>
                        </md-button>                
                    </md-menu-content>
                </md-menu>

            </div>
        </md-toolbar>
    </div>
</template>

<style scoped>
    /* h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    } */
</style>

<script>
export default {
    name: 'baseToolbar',
    props: {
        title: String,
        isAdd: String,
        isEdit: String,
        isSave: String,
        isDelete: String
        },
        data: () => ({
            layout: ""
        }),
        computed:{
            isLayoutList: function() {
                return this.layout=='list';
            },
            isLayoutCard: function() {
                return this.layout=='card';
            },
        },

        created: function () {
            $App.event.$on("app_hotkey_ctrlBackspace", this.onCtrlBackspace);
            $App.event.$on("app_hotkey_ctrlshiftN", this.onCtrlShiftN);
            $App.event.$on("app_switchLayout", this.onSwitchLayout);

        },
        destroyed: function () {
            $App.event.$off("app_hotkey_ctrlBackspace", this.onCtrlBackspace);
            $App.event.$off("app_hotkey_ctrlshiftN", this.onCtrlShiftN);
            $App.event.$off("app_switchLayout", this.onSwitchLayout);
        },
    methods: {
        back() { this.$router.go(-1); },
        onCtrlBackspace: function (e) {
            this.back();
        },
        onCtrlShiftN: function (e) {
            if(this.isAdd && this.isAdd != 'disabled') {
                this.$emit('add')
            }
        },
        onSwitchLayout: function (e) {
            if (e) { this.layout = e; }
        },
        emitSwitchLayout: function(e) {
            $App.event.$emit('app_switchLayout',e);
        }
    }
}
</script>
